import {
  assetStatusAggregationFunction,
  descriptionAggregationFunction,
  GroupDistributionAgg,
  pathAggregationFunction,
} from '@y42/ag-grid';
import { GridOptions, RowClassParams } from 'ag-grid-community';
import { EntryGroupCellRendererParams } from './entry-group-cell-renderer/entry-group-cell-renderer.component';

export function getDatasourceListViewGridOptions(cfg: {
  importActiveRowClassRule: (params: RowClassParams) => boolean;
  hideSubEntries?: boolean;
  selectionDisabled?: boolean;
  showLogo?: boolean;
  hideDetails?: boolean;
  rowSelection?: 'single' | 'multiple';
  groupDefaultExpanded?: number;
  suppressAggFuncInHeader?: boolean;
}): GridOptions {
  return {
    noRowsOverlayComponent: 'dataNoRowOverlayComponent',
    rowClass: 'cursor-pointer',
    groupHideOpenParents: false,
    suppressAggFuncInHeader: cfg.suppressAggFuncInHeader,
    animateRows: true,
    suppressRowClickSelection: cfg.selectionDisabled,
    groupDefaultExpanded: cfg.groupDefaultExpanded,
    autoGroupColumnDef: {
      cellRenderer: 'entryGroup',
      cellRendererParams: {
        showChildElements: !cfg.hideSubEntries,
        showLogo: !!cfg.showLogo,
        hideDetails: !!cfg.hideDetails,
      } satisfies EntryGroupCellRendererParams,
    },
    aggFuncs: {
      distribution: (params) => GroupDistributionAgg(params),
      description: (params) => descriptionAggregationFunction(params),
      assetStatus: (params) => assetStatusAggregationFunction(params),
      pathAggFunc: (params) => pathAggregationFunction(params),
    },
    rowClassRules: {
      'import-active': cfg.importActiveRowClassRule,
    },
    groupSelectsChildren: cfg.rowSelection === 'multiple',
    isRowSelectable: cfg.selectionDisabled ? () => false : (node) => !node.group,
    rowMultiSelectWithClick: cfg.rowSelection === 'multiple',
    rowSelection: cfg.rowSelection,
    suppressCellFocus: true,
    groupDisplayType: 'multipleColumns',
    defaultColDef: {
      sortable: true,
      resizable: true,
      suppressMovable: false,
      flex: 1,
      menuTabs: ['filterMenuTab', 'generalMenuTab'],
      filterParams: {
        suppressAndOrCondition: true,
        includeBlanksInLessThan: true,
        trimInput: false,
      },
    },
  };
}
